import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';

/**
 * ConfigService loads non-sensitive runtime configuration from lmsConfig.json.
 * API secrets and auth tokens must NEVER be placed in lmsConfig.json.
 *
 * HttpBackend is used instead of HttpClient so that this service's own
 * HTTP request bypasses the AuthInterceptor, preventing the circular
 * dependency:  AuthInterceptor → AuthService → ConfigService → HttpClient
 *              → HTTP_INTERCEPTORS → AuthInterceptor
 */
@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private config: any = {};
    private http: HttpClient;

    constructor(httpBackend: HttpBackend) {
        this.http = new HttpClient(httpBackend);
    }

    loadConfig(): Promise<void> {
        return this.http
            .get('assets/data/lmsConfig.json')
            .toPromise()
            .then((config: any) => {
                this.config = config || {};
            })
            .catch(() => {
                // Config file is optional; continue without it.
                this.config = {};
            });
    }

    get(key: string): any {
        return this.config ? this.config[key] : null;
    }
}
